import * as angular from 'angular';

class PortfolioCodeSelectionComponentCtrl implements ng.IController {
    public portfolioCodes: string[];
    public selectedPortfolioCode: string;
    public isMandatory: boolean;
    public tsoNameForHelp: string;
    public verificationByUser: boolean;
    public direction: Direction;
    public tsoNumber: number;
    public columnWidthLabel: number;
    public columnWidthSelection: number;
    public columnWidthGeneral: number;
    public formGroupForSelection: boolean;

    public ngModelCtrl: ng.INgModelController;

    $onInit(): void {
        this.ngModelCtrl.$render = () => {
            this.selectedPortfolioCode = this.ngModelCtrl.$modelValue;
            this.ngModelCtrl.$setViewValue(this.selectedPortfolioCode);
        };
    }

    public onChange(): void {
        this.ngModelCtrl.$setViewValue(this.selectedPortfolioCode);
    }
}

angular.module('app').component('pkpPortfolioCodeSelection', {
    controller: PortfolioCodeSelectionComponentCtrl,
    template: require('app/_directives/portfolio-code-selection.component.html'),
    bindings: {
        portfolioCodes: '<',
        isMandatory: '<',
        tsoNameForHelp: '<',
        verificationByUser: '=',
        direction: '<',
        tsoNumber: '<',
        columnWidthLabel: '<',
        columnWidthSelection: '<',
        columnWidthGeneral: '<',
        formGroupForSelection: '<'
    },
    require: {
        ngModelCtrl: 'ngModel'
    }
});
